// extracted by mini-css-extract-plugin
export default {"gradesEdit":"grades-edit_gradesEdit__hcqID","gradesEditContent":"grades-edit_gradesEditContent__Im4xl"};